module.exports = __webpack_public_path__ + "atlasmap-scripts.js";